/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: fRuRbcdHVNMtdcnFK96ivt
// Component: JbFhS1uokEWY
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  get as $stateGet,
  hasVariant,
  set as $stateSet,
  useCurrentUser,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: fRuRbcdHVNMtdcnFK96ivt/projectcss
import sty from "./PlasmicPageInTab2.module.css"; // plasmic-import: JbFhS1uokEWY/css

createPlasmicElementProxy;

export const PlasmicPageInTab2__VariantProps = new Array(
  "extendedLeftColumn",
  "extendedRightColumn"
);

export const PlasmicPageInTab2__ArgProps = new Array();

const $$ = {};

function PlasmicPageInTab2__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const currentUser = useCurrentUser?.() || {};
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "extendedLeftColumn",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.extendedLeftColumn
      },
      {
        path: "extendedRightColumn",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $q, $ctx }) =>
          $props.extendedRightColumn
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $q: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.root,
        {
          [sty.rootextendedLeftColumn]: hasVariant(
            $state,
            "extendedLeftColumn",
            "extendedLeftColumn"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"allWrapper"}
        data-plasmic-override={overrides.allWrapper}
        className={classNames(projectcss.all, sty.allWrapper)}
      >
        <div
          data-plasmic-name={"leftSpacer"}
          data-plasmic-override={overrides.leftSpacer}
          className={classNames(projectcss.all, sty.leftSpacer, {
            [sty.leftSpacerextendedLeftColumn]: hasVariant(
              $state,
              "extendedLeftColumn",
              "extendedLeftColumn"
            )
          })}
        />

        <div
          data-plasmic-name={"borderWrapper"}
          data-plasmic-override={overrides.borderWrapper}
          className={classNames(projectcss.all, sty.borderWrapper, {
            [sty.borderWrapperextendedLeftColumn]: hasVariant(
              $state,
              "extendedLeftColumn",
              "extendedLeftColumn"
            )
          })}
        >
          <div
            data-plasmic-name={"pageWrapper"}
            data-plasmic-override={overrides.pageWrapper}
            className={classNames(projectcss.all, sty.pageWrapper, {
              [sty.pageWrapperextendedLeftColumn]: hasVariant(
                $state,
                "extendedLeftColumn",
                "extendedLeftColumn"
              )
            })}
          >
            <div
              data-plasmic-name={"leftWrapper"}
              data-plasmic-override={overrides.leftWrapper}
              className={classNames(projectcss.all, sty.leftWrapper, {
                [sty.leftWrapperextendedLeftColumn]: hasVariant(
                  $state,
                  "extendedLeftColumn",
                  "extendedLeftColumn"
                )
              })}
              onClick={async event => {
                const $steps = {};
                $steps["updateExtendedLeftColumn"] = true
                  ? (() => {
                      const actionArgs = {
                        vgroup: "extendedLeftColumn",
                        operation: 2
                      };
                      return (({ vgroup, value }) => {
                        if (typeof value === "string") {
                          value = [value];
                        }
                        const oldValue = $stateGet($state, vgroup);
                        $stateSet($state, vgroup, !oldValue);
                        return !oldValue;
                      })?.apply(null, [actionArgs]);
                    })()
                  : undefined;
                if (
                  $steps["updateExtendedLeftColumn"] != null &&
                  typeof $steps["updateExtendedLeftColumn"] === "object" &&
                  typeof $steps["updateExtendedLeftColumn"].then === "function"
                ) {
                  $steps["updateExtendedLeftColumn"] =
                    await $steps["updateExtendedLeftColumn"];
                }
              }}
            />

            <div
              data-plasmic-name={"centerWrapper"}
              data-plasmic-override={overrides.centerWrapper}
              className={classNames(projectcss.all, sty.centerWrapper, {
                [sty.centerWrapperextendedLeftColumn]: hasVariant(
                  $state,
                  "extendedLeftColumn",
                  "extendedLeftColumn"
                )
              })}
            />

            <div
              data-plasmic-name={"rightWrapper"}
              data-plasmic-override={overrides.rightWrapper}
              className={classNames(projectcss.all, sty.rightWrapper, {
                [sty.rightWrapperextendedLeftColumn]: hasVariant(
                  $state,
                  "extendedLeftColumn",
                  "extendedLeftColumn"
                )
              })}
            />
          </div>
        </div>
        <div
          data-plasmic-name={"rightSpacer"}
          data-plasmic-override={overrides.rightSpacer}
          className={classNames(projectcss.all, sty.rightSpacer, {
            [sty.rightSpacerextendedLeftColumn]: hasVariant(
              $state,
              "extendedLeftColumn",
              "extendedLeftColumn"
            )
          })}
        />
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "allWrapper",
    "leftSpacer",
    "borderWrapper",
    "pageWrapper",
    "leftWrapper",
    "centerWrapper",
    "rightWrapper",
    "rightSpacer"
  ],

  allWrapper: [
    "allWrapper",
    "leftSpacer",
    "borderWrapper",
    "pageWrapper",
    "leftWrapper",
    "centerWrapper",
    "rightWrapper",
    "rightSpacer"
  ],

  leftSpacer: ["leftSpacer"],
  borderWrapper: [
    "borderWrapper",
    "pageWrapper",
    "leftWrapper",
    "centerWrapper",
    "rightWrapper"
  ],

  pageWrapper: ["pageWrapper", "leftWrapper", "centerWrapper", "rightWrapper"],
  leftWrapper: ["leftWrapper"],
  centerWrapper: ["centerWrapper"],
  rightWrapper: ["rightWrapper"],
  rightSpacer: ["rightSpacer"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPageInTab2__ArgProps,
          internalVariantPropNames: PlasmicPageInTab2__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicPageInTab2__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPageInTab2";
  } else {
    func.displayName = `PlasmicPageInTab2.${nodeName}`;
  }
  return func;
}

export const PlasmicPageInTab2 = Object.assign(
  // Top-level PlasmicPageInTab2 renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    allWrapper: makeNodeComponent("allWrapper"),
    leftSpacer: makeNodeComponent("leftSpacer"),
    borderWrapper: makeNodeComponent("borderWrapper"),
    pageWrapper: makeNodeComponent("pageWrapper"),
    leftWrapper: makeNodeComponent("leftWrapper"),
    centerWrapper: makeNodeComponent("centerWrapper"),
    rightWrapper: makeNodeComponent("rightWrapper"),
    rightSpacer: makeNodeComponent("rightSpacer"),
    // Metadata about props expected for PlasmicPageInTab2
    internalVariantProps: PlasmicPageInTab2__VariantProps,
    internalArgProps: PlasmicPageInTab2__ArgProps
  }
);

export default PlasmicPageInTab2;
/* prettier-ignore-end */
